"use client";

import React, { useEffect } from "react";
import Link from "next/link";
import { useSearchParams } from "next/navigation";
import queryString from "query-string";
import { Button } from "app/_components/components/Button";
import { mixpanelClient } from "analytics/mixpanel";
import storage from "config/storage";
import { useTranslations } from "i18n";

const MobileDownloadAppCTA = () => {
  const t = useTranslations("homepage");

  const searchParams = useSearchParams();
  const clickId: string | null =
    storage.get("affiliateClickId", "sessionStorage") ||
    searchParams?.get("~click_id");

  const referralCode = searchParams?.get("referralCode");

  const queryParams = queryString.stringify({
    referral: referralCode,
    ["~click_id"]: clickId
  });

  useEffect(() => {
    mixpanelClient.trackLinkClick("homepage-mobile-download-app-cta", true);
  }, [clickId]);

  return (
    <Button asChild size="lg" variant="primary">
      <Link
        href={`https://geminiexchange.app.link/fL2oDHN39pb?${queryParams}`}
        target="_self"
      >
        {t("heroDownloadText")}
      </Link>
    </Button>
  );
};

export default MobileDownloadAppCTA;
